export default function LicensingUserGroupsController() {}
